import { render, staticRenderFns } from "./cModalFormCom.vue?vue&type=template&id=4af46214"
import script from "./cModalFormCom.vue?vue&type=script&lang=js"
export * from "./cModalFormCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports